import axiosHttp from "services/axiosHttp";
import { message } from "antd";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const deleteMeeting = createAsyncThunk("deleteMeeting", async ({ id }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.patch(`meeting/${id}/cancel`, config);
	message.success("Meeting has been deleted successfully!");
	return response.data.data;
});

const MeetingDeleteSlice = createSlice({
	name: "MeetingDeleteSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(deleteMeeting.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(deleteMeeting.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(deleteMeeting.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default MeetingDeleteSlice.reducer;
